import React, { useState, } from 'react';
import { Input } from 'components/ui/input';
import { Label } from 'components/ui/label';
import { cn } from 'lib/utils';
import Text from '../Text';
import { ReactSVG } from 'react-svg';
import { hide_password_icon, show_password_icon } from 'asset/icons';

interface InputFieldProps {
  label?: string;
  required?: boolean;
  type?: string;
  placeholder?: string;
  value: string | number;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
  onPressEnter?: () => void;
  rightIcon?: string;
  props?: any;
  onPressIcon?: () => void
}

const InputField = ({
  label,
  required = false,
  type = 'text',
  placeholder,
  value,
  onChange,
  disabled = false,
  className,
  onPressEnter,
  rightIcon,
  props,
  onPressIcon
}: InputFieldProps) => {
  const isPassword = type === 'password';
  const [showPassword, setShowPassword] = useState(false);

  const showRightIcon = isPassword || rightIcon;

  return (
    <div className={cn('w-full gap-2 ', className)}>
      {label && (
        <Label className='flex items-center gap-1 px-1'>
          <Text text={label} className='text-muted-foreground' />
          {required && <span className='text-red-500'>*</span>}
        </Label>
      )}

      <div className='relative mt-2'>
        <Input
          type={isPassword && showPassword ? 'text' : type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          className={cn(
            'w-full rounded-full bg-input border-0 py-2.5 md:py-3 transition-colors duration-150',
            showRightIcon ? 'pr-12' : 'pr-4',
            disabled && 'opacity-50 cursor-not-allowed'
          )}
          onKeyDown={(e) => e.key === 'Enter' && onPressEnter?.()}

          {...props}
        />

        {/* Right Icon Area */}
        {showRightIcon && (
          <div className='absolute right-4 top-1/2 -translate-y-1/2 flex items-center'>
            {isPassword ? (
              <button
                type='button'
                onClick={() => setShowPassword((prev) => !prev)}
                className='text-muted-foreground hover:text-primary transition'
              >
                <ReactSVG
                  src={showPassword ? hide_password_icon : show_password_icon}
                />
              </button>
            ) : (
              <button
                type='button'
                onClick={onPressIcon}
                className='text-muted-foreground hover:text-primary transition'
              >
                <ReactSVG src={rightIcon}
                  beforeInjection={(svg) => {
                    svg.setAttribute('style', 'width: 20px');
                  }}
                />
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default InputField;
